import { ca } from '@cian/analytics';

import { IOfferForClient1 } from '../../repositories/chats/entities/for_client/OfferForClient1';
import { TChatbotReaction, IChatbotMessageOfferSchema } from '../../types/chatbot';
import { omitNull } from '../../utils/omitNull';
type IBaseOfferSchema = IChatbotMessageOfferSchema & IOfferForClient1;

interface ITrackShowMessageParams {
  chatId: string;
  messageId: string;
  communicationId?: string | null;
  attributes?: string;
  offer?: IBaseOfferSchema[];
}

export const trackShowMessage = ({
  chatId,
  messageId,
  communicationId,
  attributes,
  offer,
}: ITrackShowMessageParams) => {
  try {
    const products = Array.isArray(offer)
      ? offer.map(item => ({
          id: item.realtyOfferId,
          offerType: 'offer',
          position: item.position,
        }))
      : [];

    ca('eventSite', {
      name: 'oldevent',
      category: 'Chat',
      action: 'Show_sopr',
      label: 'Messages',
      page: {
        extra: {
          chat_id: chatId,
          messages_id: messageId,
          communication_id: omitNull(communicationId),
          attributes,
        },
      },
      products,
    });
  } catch (error) {
    console.debug('trackShowMessage', error);
  }
};

export const trackClickMessage = ({
  chatId,
  messageId,
  messageType,
  offerId,
  communicationId,
  clickText,
}: {
  chatId: string;
  messageId: string;
  messageType: string;
  offerId?: number;
  communicationId?: string | null;
  clickText?: string;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'Messages',
    page: {
      extra: {
        chat_id: chatId,
        messages_id: messageId,
        communication_id: omitNull(communicationId),
        message_type: messageType,
        click_text: clickText,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};

export const trackHiddenMessagePhoneClick = ({
  messageId,
  chatId,
  communicationId,
  offerId,
}: {
  messageId: string;
  chatId: string;
  communicationId?: string | null;
  offerId?: number;
}) => {
  const products = offerId ? [{ id: offerId, offerType: 'offer', position: 1 }] : [];

  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'ActionButton',
    products,
    page: {
      extra: {
        chat_id: chatId,
        messages_id: messageId,
        communication_id: omitNull(communicationId),
        promoName: 'phone',
      },
    },
  });
};

export const trackLike = (
  offerId: number,
  reaction?: TChatbotReaction,
  communicationId?: string | null,
  position?: number,
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: reaction === 'like' ? 'Click_sopr' : 'Remove_sopr',
    label: 'Good',
    page: {
      extra: {
        chat_id: 'chatbot',
        communication_id: omitNull(communicationId),
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
};
